import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="relative min-h-[60vh] md:min-h-screen flex items-center pt-16 md:pt-20 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/6085fca3-55c9-4d16-bb48-617fc189dc44.jpg" 
          alt="Golfbane i Spanien" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-l from-slate-900/60 via-slate-900/30 to-transparent"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8 md:pt-40 md:pb-20">
        <div className="max-w-4xl ml-auto text-right">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-3xl md:text-6xl font-medium text-white leading-tight mb-6 uppercase">
              Golfrejser til Spanien for dig, der har tid til at nyde livet
            </h1>
            <p className="text-base md:text-xl text-slate-200 mb-6 md:mb-10 leading-relaxed max-w-2xl ml-auto">
              Longstay golfophold i Cádiz og Costa de la Luz med lejlighed, fri golf, socialt fællesskab og personlig hjælp fra start til slut.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-end">
              <Link 
                to="/kontakt" 
                className="inline-flex items-center justify-center px-6 py-3 md:px-8 md:py-4 rounded-full border-2 border-white bg-transparent text-white font-semibold text-base md:text-lg hover:-translate-y-1 transition-all shadow-lg shadow-black/20 group"
              >
                Book dit ophold
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Link>
              <Link 
                to="/kontakt" 
                className="inline-flex items-center justify-center px-6 py-3 md:px-8 md:py-4 rounded-full bg-[#39d14b] border border-[#39d14b] text-white font-semibold text-base md:text-lg hover:-translate-y-1 transition-all shadow-lg shadow-[#39d14b]/20"
              >
                Kontakt os i dag
              </Link>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 1 }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 hidden md:block"
      >
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center p-1">
          <motion.div 
            animate={{ y: [0, 12, 0] }}
            transition={{ repeat: Infinity, duration: 1.5 }}
            className="w-1 h-2 bg-white rounded-full"
          />
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;
